import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=22b0e2ed&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=22b0e2ed&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0e2ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b0e2ed')) {
      api.createRecord('22b0e2ed', component.options)
    } else {
      api.reload('22b0e2ed', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=22b0e2ed&scoped=true", function () {
      api.rerender('22b0e2ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/empty.vue"
export default component.exports